import "./Artists.module.css";
import Navigation from "@/reusable_sections/Header";
import TheRoster from "./sections/TheRoster";
import Footer from "@/reusable_sections/Footer";
export default function ArtistsPage() {
  return <div>
      <Navigation />
      <TheRoster />
      <Footer />
    </div>;
}